import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-book mr1" }, null, -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Tutorial ")
const _hoisted_3 = { class: "container-centered p2" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  class: "k-cat-source-label"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Back to Menu ")

import { CapacitorHttp, HttpResponse } from '@capacitor/core';
    import { ref } from 'vue';
    import NavigableScreen from 'components/navigable-screen.vue';
    import NavButton from 'components/nav-button.vue';
    import Spinner from 'src/components/spinner.vue';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'tutorial-menu',
  emits: ['back'],
  setup(__props, { emit }) {

    const imgReady = ref(false);
    const imgSrc = ref<string>();
    const imgError = ref(false);
    (async () => {
        try {
            //const response = await fetch('https://cataas.com/cat');
            const res = await CapacitorHttp.get({ url: 'https://cataas.com/cat', responseType: 'blob' });
            const blob = res.data as Blob;
            
            //const blob = await response.blob();
            imgSrc.value = URL.createObjectURL(blob);
            imgReady.value = true;
        } catch (error){
            imgSrc.value = 'images/IMG_cat.jpg';
            imgReady.value = true;
            imgError.value = true;
        }
    })();

    const handleImageLoaded = () => imgReady.value = true;
    const handleImageLoadError = () => {
        imgSrc.value = 'images/IMG_cat.jpg';
        imgReady.value = true;
        imgError.value = true;
    }

    
    const handleNativeBack = () => emit('back');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigableScreen, {
    "use-banner-offset": "",
    onNativeBack: handleNativeBack
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2
    ]),
    content: _withCtx(() => [
      _createVNode(_Transition, {
        name: "slide-fade",
        appear: ""
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _withDirectives(_createVNode(Spinner, null, null, 512), [
              [_vShow, !imgReady.value]
            ]),
            _withDirectives(_createElementVNode("img", {
              src: imgSrc.value,
              class: "k-cat-img",
              onLoad: handleImageLoaded,
              onError: handleImageLoadError
            }, null, 40, _hoisted_4), [
              [_vShow, imgReady.value]
            ]),
            (imgReady.value && !imgError.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, " Courtesy of https://cataas.com/ "))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      })
    ]),
    "nav-center": _withCtx(() => [
      _createVNode(NavButton, {
        type: "back",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('back')))
      }, {
        default: _withCtx(() => [
          _hoisted_6
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})